import { DateTimeField } from "@hex-insights/forms";
import { StudentAttendanceNoteFormValues } from "../../FormUtilities";
import { AttendanceStatusSelectField } from "../AttendanceStatus";
import { BaseFieldProps } from "../shared";
import { StudentNoteSelectField } from "../StudentNote";

/**
 * Generic props for fields of the StudentAttendanceNote model.
 */
type FieldProps<K extends keyof StudentAttendanceNoteFormValues.Base = keyof StudentAttendanceNoteFormValues.Base> =
	BaseFieldProps<Pick<StudentAttendanceNoteFormValues.Base, K>>;

/**
 * Field component for the `startDate` field of the StudentAttendanceNote model.
 */
export function StartDate({ formState, ...props }: FieldProps<"startDate">) {
	return <DateTimeField formState={formState} name="startDate" precision="day" {...props} />;
}

/**
 * Field component for the `endDate` field of the StudentAttendanceNote model.
 */
export function EndDate({ formState, ...props }: FieldProps<"endDate">) {
	return <DateTimeField formState={formState} name="endDate" precision="day" {...props} />;
}

export namespace AttendanceStatus {
	export type SelectProps = FieldProps<"attendanceStatusID"> &
		Omit<
			AttendanceStatusSelectField.SelectProps<StudentAttendanceNoteFormValues.Base>,
			"formState" | "name" | "optional"
		>;

	/**
	 * Field component for the `attendanceStatus` edge of the StudentAttendanceNote model.
	 */
	export function Select({
		formState,
		hint = "What should the student's attendance status be set to by default on the selected dates?",
		...props
	}: SelectProps) {
		return (
			<AttendanceStatusSelectField.Select
				formState={formState}
				name="attendanceStatusID"
				optional
				hint={hint}
				{...props}
			/>
		);
	}
}

export namespace StudentNote {
	export type SelectProps = FieldProps<"studentNoteID"> &
		Omit<StudentNoteSelectField.SelectProps<StudentAttendanceNoteFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `studentNote` edge of the StudentAttendanceNote model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <StudentNoteSelectField.Select formState={formState} name="studentNoteID" {...props} />;
	}
}
